import React from 'react';
import { Title, TitleProps, Text, Tag } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface BlockTitleFiltersProps {
    title?: string;
    titleTag?: TitleProps['component'];
    text?: string;
    variant?: 'testimonial' | 'mediaLarge';
    filters?: string[];
    onClickFilter?: (filter: string) => void;
    filterSelected: string | null;
}

const BlockTitleFilters = ({
    title,
    titleTag,
    text,
    variant,
    filters,
    onClickFilter,
    filterSelected,
}: BlockTitleFiltersProps) => {
    return (
        <div className="row mb-xl gap-y-24">
            {(title || text) && (
                <div
                    className={cls(
                        'col-span-full flex flex-col gap-y-24',
                        !!filters?.length && 'lg:col-span-4 xl:col-span-6',
                    )}>
                    {title && (
                        <Title
                            component={titleTag ?? 'h3'}
                            className={cls('text-h300 text-text-primary')}>
                            {title}
                        </Title>
                    )}
                    {text && (
                        <Text
                            isHtml
                            component="div"
                            className={cls('text-b300 text-text-secondary')}>
                            {text}
                        </Text>
                    )}
                </div>
            )}

            {filters && filters.length > 0 && (
                <div
                    className={cls(
                        'col-span-full lg:col-span-4 xl:col-span-6 flex gap-8 items-start lg:justify-end',
                        !title &&
                            'lg:col-span-full xl:col-span-full lg:justify-start',
                    )}>
                    {filters &&
                        filters.map((filter) => (
                            <Tag
                                key={`filter-${filter}`}
                                variant="filter"
                                onClick={() => {
                                    typeof onClickFilter === 'function' &&
                                        onClickFilter(filter);
                                }}
                                active={filterSelected === filter}>
                                {filter}
                            </Tag>
                        ))}
                </div>
            )}
        </div>
    );
};

export default BlockTitleFilters;
